// Zvětšení obrázku na desktopu

import { galleryState as state } from './galleryState';
import { scrollToTop } from '@utils/scroll';

// Zobrazit / skrýt modal
export const toggleModalGalleryZoom = () => {
  const zoomModal: HTMLElement | null = document.querySelector('[data-gallery-zoom-modal]');
  if (!zoomModal) throw new Error('removeCloseZoomListeners: zoomModal not found');
  const zoomClose: HTMLElement | null = zoomModal.querySelector('[data-gallery-zoom-close]');

  if (zoomModal) {
    if (zoomModal.style.display === 'none' || zoomModal.style.display === '') {
      zoomModal.style.display = 'block';
    } else {
      zoomModal.style.display = 'none';
      scrollToTop();

      // Odebrat naslouchání na zavření zoom modálního okna
      if (zoomClose) {
        zoomClose.removeEventListener('click', (e) => {
          e.preventDefault();
        });
        zoomModal.removeEventListener('click', toggleModalGalleryZoom);
      }
    }
  }
};

// Přidat/odebrat naslouchání na toggle zoom modálního okna
export const addCloseZoomListeners = () => {
  const zoomModal: HTMLElement | null = document.querySelector('[data-gallery-zoom-modal]');
  if (!zoomModal) throw new Error('removeCloseZoomListeners: zoomModal not found');
  const zoomClose: HTMLElement | null = zoomModal.querySelector('[data-gallery-zoom-close]');

  if (zoomClose && zoomModal) {
    zoomClose.addEventListener('click', (e) => {
      e.preventDefault();
    });
    zoomModal.addEventListener('click', toggleModalGalleryZoom);
  }
};

export const handleZoom = (e: Event) => {
  // Načíst odkaz na obrázek
  const target = e.currentTarget as HTMLElement;
  const { galleryItemZoom } = target.dataset;

  // Na desktopu ve slideru
  if (state.getIsSlideOrScroll()) {
    // Načíst obrázek
    const zoomImage: HTMLImageElement | null = document.querySelector('[data-gallery-zoom-image]');
    if (zoomImage && galleryItemZoom) zoomImage.src = galleryItemZoom;

    // Zobrazit v modálním okně
    toggleModalGalleryZoom();
  }

  addCloseZoomListeners();
};
